/**
 * Como se pega lo dictado a lo que ya hay escrito.
 *
 * Vive aparte del compositor porque lo usan DOS sitios que tienen que estar de
 * acuerdo: el que dibuja la vista previa y el que la consolida. Si cada uno
 * calculara el espacio por su cuenta, el texto daria un salto de un pixel justo
 * al confirmarse, que es el tipo de detalle que se ve y no se sabe explicar.
 */

/**
 * Se pega detras de lo que ya hubiera, con un espacio si hace falta. Dictar
 * dos veces seguidas tiene que dar dos frases, no dos frases pegadas.
 */
export const joinTranscript = (current: string, transcript: string): string => {
  const addition = transcript.trim();
  if (addition === "") return current;
  if (current.trim() === "") return addition;
  return /\s$/.test(current)
    ? `${current}${addition}`
    : `${current} ${addition}`;
};

export interface TranscriptPreview {
  /** Lo que ya es texto del usuario y se dibuja normal. */
  readonly confirmed: string;
  /** Lo que todavia es provisional y se dibuja en cursiva. */
  readonly provisional: string;
}

/**
 * Parte lo que se VERIA en la caja si el dictado se consolidara ahora mismo.
 *
 * Se deriva de `joinTranscript` en vez de repetir su regla, para que la vista
 * previa y lo que acaba escrito no puedan discrepar.
 *
 * El caso raro: si lo que hay escrito son solo espacios, `joinTranscript` los
 * tira, asi que el prefijo no sobrevive y la vista previa pasa a ser la frase
 * entera. Visualmente da igual --lo que se pierde son espacios, que no se
 * ven-- y evita que la parte normal y la cursiva se solapen.
 */
export const previewOf = (
  current: string,
  transcript: string,
): TranscriptPreview => {
  const joined = joinTranscript(current, transcript);

  return joined.startsWith(current)
    ? { confirmed: current, provisional: joined.slice(current.length) }
    : { confirmed: "", provisional: joined };
};
